import type { ParlayProps } from "../../../../types";

export const ParlayHelpers = {
    calcAvailable: (parlay:ParlayProps):number => {
        if(parlay.offer_side == 'taker'){
            return parlay.potential_winnings - parlay.open_amt
        } else {
            return parlay.open_amt
        }
    }
}